import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCompanyInfo, setUserDetail } from 'commonSlice/commonSlice';
import { useEffect } from 'react';
import axios from 'axios';
import { baseUrl } from 'config';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const billType = useSelector((state) => state.posSlice.billType);

  const isB2C = billType === "B2C";

  // Function to toggle fullscreen mode
  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(`Error attempting to enable fullscreen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen();
    }
  }, []);

  // Function to navigate to home
  const handleHomeClick = () => {
    navigate('/');
  };

  useEffect(() => {
    function getCompany() {
      axios
        .get(baseUrl + "/main/getCompanyDetails", { withCredentials: true })
        .then((res) => {
          dispatch(setCompanyInfo(res.data[0]));
        });
    }
    function getUser() {
      axios
        .get(baseUrl + "/main/getUserDetails", { withCredentials: true })
        .then((res) => {
          dispatch(setUserDetail(res?.data));
        });
    }
    getCompany();

    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppBar
      position="static"
      sx={{
        background: isB2C ? '#6D4C41' : 'rgb(108, 69, 185)',
        px: 2,
        py: 1,
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', p: 0 }}>
        {/* Left: Logo and Company Name */}
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar
            alt="Logo"
            src="/logo192.png"
            sx={{ width: 32, height: 32 }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 600, color: 'white' }}
          >
            Wizzo Dine
          </Typography>
        </Box>

        {/* Right: Fullscreen and Home Icons */}
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton color="inherit" onClick={toggleFullScreen}>
            <FullscreenIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleHomeClick}>
            <HomeIcon />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
